var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgPublish1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 388,
    height: 841,
    viewBox: "0 0 388 841",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-BG_type1_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 388,
    height: 841
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BG_type1_4",
    "data-name": "BG_type1 \\u2013 4",
    clipPath: "url(#clip-BG_type1_4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 388,
    height: 841,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_172",
    "data-name": "Group 172"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157",
    "data-name": "Rectangle 157",
    width: 388,
    height: 841,
    fill: "#006"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96",
    "data-name": "Ellipse 96",
    cx: 205.5,
    cy: 205.5,
    r: 205.5,
    transform: "translate(-273 -307)",
    fill: "#0000af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M56.65,8.056Q61.741,1.039,67.479.092T84.042,8.056q4.45,5.091,11.785,12.1,7.315,7,15.288,15.606,7.958,8.6,16.881,18.155t17.2,19.11a22.474,22.474,0,0,1,6.371,12.1q1.267,7-3.823,14.015L98.055,177.5q-3.82,5.734-6.688,7.325c-1.91,1.055-3.612,1.275-5.1.638a15.956,15.956,0,0,1-4.777-3.5,48.558,48.558,0,0,0-5.1-4.459L3.142,117.621q-5.106-5.1-1.911-13.058A105.235,105.235,0,0,1,9.511,88.319q12.094-22.306,23.569-43A352.063,352.063,0,0,1,56.65,8.056",
    transform: "translate(-89.909 124)",
    fill: "#ff1335"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_97",
    "data-name": "Ellipse 97",
    cx: 225,
    cy: 225,
    r: 225,
    transform: "translate(303 79)",
    fill: "#6ee7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    d: "M-9309-4517.5c-73,12-137.5,44.5-197.5,158.5s-52.166,136-113.5,276-218.667,249.667-346.667,293.667",
    transform: "translate(9799 4549)",
    fill: "none",
    stroke: "#0000af",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    d: "M-9309-4517.5c-73,12-149.484,70.892-179.447,171.8s-42.241,219.426-141.827,332.5-262.538-44.151-390.538-.151",
    transform: "translate(8746.453 6218.633) rotate(11)",
    fill: "none",
    stroke: "#0000af",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M-9309-4517.5c-73,12-149.484,70.892-179.447,171.8s-13.075,256.524-112.661,369.6-291.7-81.249-419.7-37.249",
    transform: "matrix(0.921, 0.391, -0.391, 0.921, 7279.947, 7790.472)",
    fill: "none",
    stroke: "#0000af",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M-9454-4572.667s-66,67.333-129.333,70.667S-9696-4566-9716-4584.667",
    transform: "translate(9785 4543)",
    fill: "none",
    stroke: "#0000af",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M-9820.667-4434.667c42,11.333,132.668-.667,149.334,36.667s-17.333,121.333-124,190",
    transform: "translate(9785 4543)",
    fill: "none",
    stroke: "#0000af",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_98",
    "data-name": "Ellipse 98",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(314 142)",
    fill: "#1c1cff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_103",
    "data-name": "Ellipse 103",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(305 20)",
    fill: "#1c1cff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_100",
    "data-name": "Ellipse 100",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(308 151)",
    fill: "#fde047"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_104",
    "data-name": "Ellipse 104",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(123 9)",
    fill: "#fde047"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_102",
    "data-name": "Ellipse 102",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(334 47)",
    fill: "#6ee7b7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_99",
    "data-name": "Ellipse 99",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(320 133)",
    fill: "#ff1335"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_101",
    "data-name": "Ellipse 101",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(343 41)",
    fill: "#ff1335"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_105",
    "data-name": "Ellipse 105",
    cx: 225,
    cy: 225,
    r: 225,
    transform: "translate(-138 486)",
    fill: "#0000af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M99.276,14.117Q108.2,1.822,118.253.162t29.025,13.955q7.8,8.922,20.652,21.21,12.819,12.27,26.791,27.349Q208.667,77.748,224.3,94.492q15.619,16.746,30.141,33.49a39.384,39.384,0,0,1,11.164,21.209q2.22,12.271-6.7,24.56L171.836,311.058q-6.694,10.048-11.721,12.837c-3.348,1.849-6.33,2.234-8.93,1.118a27.962,27.962,0,0,1-8.372-6.14,85.092,85.092,0,0,0-8.931-7.815L5.505,206.124q-8.948-8.946-3.349-22.884a184.42,184.42,0,0,1,14.512-28.466q21.194-39.09,41.3-75.353a616.973,616.973,0,0,1,41.305-65.3",
    transform: "translate(254.974 640.063)",
    fill: "#fde047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M-9503.333-4332.333c-23,50.333-42,197.667-5.334,267s181.334,138,181.334,138",
    transform: "translate(9785 4543)",
    fill: "none",
    stroke: "#0000af",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M-9619.5-4337.5c-33.75,52.5-22.75,165-77.5,211.75",
    transform: "translate(9785 4543)",
    fill: "none",
    stroke: "#0000af",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPublish1);
export default __webpack_public_path__ + "static/media/bg_publish1.51023a23b28edd37a2abe9de76249a06.svg";
export { ForwardRef as ReactComponent };